import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-top: 20px;
`;

const StyledHeading = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	min-height: 1px;
	background-color: rgba(255, 255, 255, 0.1);
`;

const StyledNewsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding-bottom: 20px;
`;

const StyledNoNewsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;

	${Text} {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledNewsItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 26px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 5px;
	padding: 20px;
`;

const StyledNewsHead = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;

	& > ${Text}:first-child {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}

	& > ${Text}:last-child {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledTextContainer = styled.div`
	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledReadMoreButton = styled.button`
	width: 157px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	border: none;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	cursor: pointer;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

export {
	StyledContainer,
	StyledDivider,
	StyledHeading,
	StyledNewsContainer,
	StyledNewsHead,
	StyledNewsItemContainer,
	StyledNoNewsContainer,
	StyledReadMoreButton,
	StyledTextContainer,
};
